
import Vue from 'vue'

const actions = {

    async List(_, { idCustomer = 0, idProduct = 0 } = {}) {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`equipmentwarranty/list`, {
                headers: { "content-type": "application/json" },
                params: { idCustomer, idProduct }
            });
            if (result.data) {
                return result.data.result;
            }
            return [];
        } catch (ex) {
            return { success: false, message: `Error to list equipment warranties: [${ex}]` };
        }
    },

    async GetById(_, id) {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`equipmentwarranty/${id}`, {
                headers: { "content-type": "application/json" }
            });
            if (result.data) {
                return result.data.result;
            }
            return null;
        } catch (ex) {
            return { success: false, message: `Error to get equipment warranty: [${ex}]` };
        }
    },

    async CreateUpdate(_, request) {
        try {
            const result = await Vue.prototype.$vanKirkApi.post(`equipmentwarranty/create-update`, request, {
                headers: { "content-type": "application/json" }
            });
            if (result.data) {
                return result.data;
            }
            return { success: false };
        } catch (ex) {
            return { success: false, message: `Error to save equipment warranty: [${ex}]` };
        }
    },

    async Delete(_, id) {
        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`equipmentwarranty/${id}`, {
                headers: { "content-type": "application/json" }
            });
            if (result.data) {
                return result.data;
            }
            return { success: false };
        } catch (ex) {
            return { success: false, message: `Error to delete equipment warranty: [${ex}]` };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
